<div class="clear"></div>
<section class="banner">
	<div class="container py-3">
		<h1>Complaints</h1>
	</div>
</section>
<div class="class py-3"></div>
<section class="container mt-5 mb-5">
	<div class="d-flex justify-content-between">
		<h5 class="text-black font-weight-medium">EPADS UAN: <a href="tel:051111137237" class="text-primary font-weight-bold">051-111-137-237</a></h5>
        <h5 class="text-black font-weight-medium">EPADS Email: <a href="mailto:epadshelp@ppra.org.pk" class="text-primary font-weight-bold">epadshelp@ppra.org.pk</a></h5>
	</div>
</section>
